module.exports = __webpack_public_path__ + "img/ivydad-header-logo-slogen.05e0786a.png";